<template>
  <div 
  class="moow-master-container play-background"
  v-loading.fullscreen="loading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading">
    <nav-basic :progress="65" :btn="false" title="" :disable="disableNext"></nav-basic>
    <div class="container">
      <b-row class="step-header">
        <p class="moow-header">Let’s add some photos</p>
      </b-row>
      <b-row>
        <b-col class="pt-2 form-container amenities-form">
        <p>Upload new photographs that showcase how your rental can be turned into a temporary home/workspace for mid-term rents or a cozy place to live for longer term. Get a floorplan done. </p>
          <md-card class="island-card pr-3 pl-3">
            <md-card-content>
              <multi-image-uploader :startWithImages="existingImages" :onProgress="uploadStatus" :onSuccess="uploadSuccess" :onError="uploadError"></multi-image-uploader>
            </md-card-content>
          </md-card>

          <b-row class="mt-5 step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <b-button :disabled="isSaving" @click="prev" variant="outline-primary" class="btn-step-navigator">Back</b-button>
            </b-col>
            <b-col style="text-align:left;padding:0">
              <b-button v-if="!isSuccess" @click="skip" class="btn-step-navigator" id="skip-add-img-btn">Skip for now</b-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <b-button :disabled="isSaving || disableNext" @click="next" variant="primary" class="btn-step-navigator">Next</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

  </div>
</template>


<script>
  import MultiImageUploader from '../components/multiImageUploader.vue';
  import {
    uploadImages
  } from '../imageFunctions.js'
  let gd = JSON.parse(sessionStorage.getItem('genDet'))
  const h = this.$createElement;
  let alreadySaved = false
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  export default {
    components: {
        'multi-image-uploader': MultiImageUploader
    },
    data() {
      return {
        fileList2: [],
        dialogImageUrl: '',
        dialogVisible: false,
        loading: false,
        loadingText: '',
        pictureUrls: [],
        thumbUrls: [],
        picAdded: false,
        fileCount: 0,
        uploadFieldName: '',
        currentStatus: STATUS_INITIAL,
        tempThumbHolder: new Object(),
        tempThumbHolders: [],
        imageIdCounterGlobal: -1,
        processedThumbsCounterGlobal: 0,
        existingImages: [],
        initialNextEnabler: false
      };
    },
    created() {
      if(this.$store.getters.marketingDet.images && this.$store.getters.marketingDet.images.length > 0){
        this.existingImages = this.$store.getters.marketingDet.images
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      genDet() {
        return this.$store.getters.genDet
      },
      disableNext(){
        if(this.isSaving) return true
        if(this.tempThumbHolders.length <= 0) return true
        return false
      }
    },
    watch: {
      thumbUrls: function (val) {
        if(this.thumbUrls.length > 0){
          sessionStorage.setItem('uploadedSomeImages', true)
        }else{
          sessionStorage.setItem('uploadedSomeImages', false)
        }
      }
    },
    methods: {
      skip(){
        sessionStorage.setItem('sceneStatus', 1)
        sessionStorage.setItem('priceStatus', 0)
        this.leavePage("SCENE1", "scene2")
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      goToDashboard(){
        this.$router.push({
          name: 'dashboard',
        })
      },
      reset() {
        this.currentStatus = STATUS_INITIAL
        this.uploadError = null
      },
      uploadStatus(status, tempImageHolders){
        this.currentStatus = status
        if(status === STATUS_INITIAL){
          this.tempThumbHolders = tempImageHolders
        }
      },
      uploadSuccess(tempImageHolders){
        console.log('scene1 | uploadSuccess | tempImageHolders:', tempImageHolders);
        
        this.tempThumbHolders = tempImageHolders
        this.currentStatus = STATUS_SUCCESS
      },
      uploadError(msg){
        this.currentStatus = STATUS_FAILED
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      next() {
        if (!alreadySaved) {
          let md = this.$store.getters.marketingDet
          md.images = this.tempThumbHolders.map(holder => {
            return {
              url: holder.origImgUrl,
              thumb: holder.imgUrl,
              cover: false,
              caption: this.getCaption(holder.aboutImage),
              aboutImage: holder.aboutImage
            }
          })
          this.$store.commit('UPDATE_MARKETINGDET', md)
        }
        this.$router.push({
          name: 'scene11',
        })
      },
      getCaption(predictions){
        try{
          return predictions.predictions["0"].room_class_1;
        }catch(err){
          return ""
        }
      },
      prev() {
        // sessionStorage.setItem('techDet', JSON.stringify(this.techDet))
        this.$router.push({
          name: 'addListing1',
        })
      }
    }
  }
</script>
<style scoped>
  @import '../assets/styles/add-steps.css';
  @import '../assets/styles/images.css';


  .photo-uploded{
    padding: 15px;
  }
  #skip-add-img-btn{
    width: 100%;
    background: lightgrey;
    border:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/scene1.vue